<!-- header uses transclusion to embed the stepper button and status badge -->
@if (!isFirstNotification) {
    <div class="arrow-left cursor-pointer" (click)="navigateToPreviousNotificationDetails()">
        <span class="arrow-icon-left d-none d-lg-block"></span>
        <fa-icon class="d-block d-lg-none" [icon]="faChevronLeft"></fa-icon>
    </div>
}
@if (!isLastNotification) {
    <div class="arrow-right cursor-pointer" (click)="navigateToNextNotificationDetails()">
        <span class="arrow-icon-right d-none d-lg-block"></span>
        <fa-icon class="d-block d-lg-none" [icon]="faChevronRight"></fa-icon>
    </div>
}
<div class="scroll-container safe-area-bottom" [@slide]="getAnimationData()">
    <!-- Header -->
    <div
        class="header card row mb-1 mt-3 mx-0 mx-lg-0 py-2 p-lg-0"
        (swipeleft)="navigateToNextNotificationDetails()"
        (swiperight)="navigateToPreviousNotificationDetails()"
    >
        <div class="col my-1">
            <pace-header [notification]="notification">
                <div class="row d-none d-lg-block">
                    <div class="col">
                        <pace-status-step-button
                            id="availableStatus"
                            class="float-end mb-3"
                            [notification]="notification"
                        ></pace-status-step-button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4 offset-3 ps-0 d-none d-lg-block">
                        @if (notification.userStatus) {
                            <fa-icon class="me-1" [icon]="faFlag"></fa-icon>
                        }
                        <span>{{ notification.userStatus }}</span>
                    </div>
                    <div class="col-4 ms-auto d-none d-lg-block">
                        <pace-notification-status-badge
                            [notification]="notification"
                            [notificationStatus]="notification.updatedStatus"
                        ></pace-notification-status-badge>
                    </div>
                </div>
            </pace-header>
        </div>
    </div>

    <!-- Notification Long Text -->
    <div
        class="row"
        (swipeleft)="navigateToNextNotificationDetails()"
        (swiperight)="navigateToPreviousNotificationDetails()"
    >
        <div class="col">
            <pace-longtext class="my-2" [notification]="notification"></pace-longtext>
        </div>
    </div>

    <!-- Details Carousel -->
    <div
        (swipeleft)="allowSwipe && navigateToNextNotificationDetails()"
        (swiperight)="allowSwipe && navigateToPreviousNotificationDetails()"
    >
        <div class="row">
            <div class="col">
                <pace-details-carousel class="mb-2" [notification]="notification"></pace-details-carousel>
            </div>
        </div>
    </div>

    <!-- Actions -->
    <div
        class="row"
        (swipeleft)="navigateToNextNotificationDetails()"
        (swiperight)="navigateToPreviousNotificationDetails()"
    >
        <div class="col">
            <pace-actions [notification]="notification"></pace-actions>
        </div>
    </div>
</div>
<div class="fixed-bottom safe-area-bottom">
    <div class="d-lg-none d-flex justify-content-between bg-light">
        <pace-status-step-button
            id="availableStatus"
            [notification]="notification"
            [isDropup]="true"
        ></pace-status-step-button>
    </div>
</div>
